export class AnnualMeetingPage {
    constructor() {
        $(() => {
            this.setupScrollHighlight();
            this.initializeFileView();
        });
    }

    private setupScrollHighlight(): void {
        const navItems = $('.sticky-menu .nav-items');

        navItems.on('click', function (event) {
            event.preventDefault();

            const targetSelector = $(this).attr('href');
            if (!targetSelector) return;

            const targetSection = $(targetSelector);
            if (!targetSection.length) return;

            const navbar = $("header").find("nav");
            const navheight = navbar.outerHeight() ?? 0;
            const padHeight = 50;

            const sectionOffset = targetSection.offset()?.top ?? 0;
            let targetOffset = sectionOffset - navheight - padHeight;
            if (targetOffset < 0) targetOffset = 0;

            $('html, body').animate({ scrollTop: targetOffset }, 800);

            navItems.removeClass('active');
            $(this).addClass('active');
        });

        $(window).on('scroll', () => {
            const scrollY = $(window).scrollTop() ?? 0;

            const navbar = $("header").find("nav");
            const navheight = navbar.outerHeight() ?? 0;
            const padHeight = 150;

            let activeNav: JQuery<HTMLElement> | undefined;

            navItems.each((_, item) => {
                const href = $(item).attr('href');
                if (!href) return;

                const section = $(href);
                if (!section.length) return;

                const sectionTop = section.offset()?.top ?? 0;
                const targetOffset = sectionTop - navheight - padHeight;

                if (scrollY >= targetOffset) activeNav = $(item);
            });

            // optional: keep first active when above everything
            if (!activeNav && navItems.length) activeNav = $(navItems[0]);

            navItems.removeClass('active');
            activeNav?.addClass('active');
        });

        $(window).trigger('scroll');
    }

    private initializeFileView() {
        $(".file-view-link").on('click', (e) => {
            let target = $(e.currentTarget);
            let link = target.data("link");
            let title = target.data("title");
            if (link) {
                let viewModal = $("#view-document-modal");
                let titleBlock = viewModal.find("#filename");
                let iframeBlock = viewModal.find("#document-iframe");

                titleBlock.text(title);
                iframeBlock.attr("src", link);

                viewModal.modal('show');
            }
        })
    }

}
